import moment from 'moment';
import { useEffect, useRef } from 'react';

// 전역에서 사용 되는 함수들입니다.

//커스텀 훅스 처음 렌더 시 이벤트 방지
export const useDidMountEffect = (func: any, deps: any) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) func();
    else didMount.current = true;
  }, deps);
};

//styled-components background-image
export const GetStyledCompImg = (src: any) => {
  try {
    const img = require(`assets/Desktop/images/${src}`).default;

    return img;
  } catch (e) {
    return '이미지 에러';
  }
};

export const GetMobileStyledCompImg = (src: any) => {
  try {
    const img = require(`assets/Mobile/images/${src}`).default;

    return img;
  } catch (e) {
    return '이미지 에러';
  }
};

export const GetCommonDate = (date: string, format = 'YYYY년 MM월 DD일') => {
  return moment(date).format(format);
};

export const GetGeocode = (address: string): Promise<naver.maps.Service.AddressItemV2> => {
  return new Promise<naver.maps.Service.AddressItemV2>((resolve: any, reject: any) => {
    try {
      naver.maps.Service.geocode({ query: address }, (status, response) => {
        if (status !== naver.maps.Service.Status.OK) {
          reject();
        } else {
          if (response.v2.addresses.length <= 0) {
            reject();
          } else {
            const item: naver.maps.Service.AddressItemV2 = response.v2.addresses[0];

            resolve(item);
          }
        }
      });
    } catch (e) {
      reject(e);
    }
  });
};

export const setWithExpiry = (key, value, ttl) => {
  const now = new Date();

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value: value,
    expiry: now.getTime() + ttl
  };

  localStorage.setItem(key, JSON.stringify(item));
};

export const getWithExpiry = key => {
  const itemStr = localStorage.getItem(key);

  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }

  const item = JSON.parse(itemStr);
  const now = new Date();

  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);

    return null;
  }

  return item.value;
};

export const contentsReplaceNewline = (contents: string) => {
  return contents && replaceAll(contents, '\n', '<br />');
};

/**
 * 문자열 내부를 조건에 맞는 문자를 검색해 특정 문자로 전부 치환
 * @param n 검사할 문자열
 * @param org 바꿀 문자열
 * @param dest 치환할 문자열
 * @return (string) 정리된 문자열 반환
 */
export const replaceAll = (n: string, org: string, dest: string) => {
  return n && n.split(org).join(dest);
};

/**
 * 입력한 날짜가 현재 날짜보다 이전인지 검사
 * @param endDate 입력하고자 할 날짜
 * @returns
 */
export const isBefore = endDate => {
  const pEndDate: string = moment(endDate).format('YYYY-MM-DD HH:mm');
  const parseEndDate = moment(new Date(pEndDate).getTime()).add(1, 'day');
  return moment().isBefore(parseEndDate);
};

/**
 * 입력한 날짜가 현재 날짜보다 이후인지 검사
 * @param startDate 입력하고자 할 날짜
 * @returns
 */
export const isAfter = startDate => {
  const pStartDate: string = moment(startDate).format('YYYY-MM-DD HH:mm');
  const parseStartDate = moment(new Date(pStartDate).getTime());
  return parseStartDate.isAfter(moment());
};

/**
 * IE인지 여부를 리턴한다.
 * @returns IE인지 여부
 */
export const isIE = () => {
  const agt = navigator.userAgent.toLowerCase();
  return (navigator.appName == 'Netscape' && navigator.userAgent.search('Trident') != -1) || agt.indexOf('msie') != -1;
};

export const isEmptyString = (value: string) => {
  const replaceValue = replaceAll(value, ' ', '');
  if (replaceValue.length === 0) {
    return true;
  } else {
    return false;
  }
};
